import { createBrowserHistory } from 'history';
var str = window.location.pathname,
    delimiter = '/',
    tokens = str.split(delimiter).slice(1,2),
    result = delimiter + tokens.join(delimiter);
export const history = createBrowserHistory({ basename: result });